import React, { useState, useEffect } from "react";
import { defaultSeriesValueWidgetData } from "./DefaultSeriesValueWidgetData";
import Card from 'react-bootstrap/Card';
import SeriesWidget from "../SeriesWidget/SeriesWidget";

const monthMapping = {
    "01": "Jan.",
    "02": "Feb.",
    "03": "Mar.",
    "04": "Apr.",
    "05": "May",
    "06": "Jun.",
    "07": "Jul.",
    "08": "Aug.",
    "09": "Sep.",
    "10": "Oct.",
    "11": "Nov.",
    "12": "Dec."
  };

const SeriesValueWidget = ({ endpoint, datasource, requestHandler, title, filter, startYear,
  profileId, solutionId, widgetClassName, chartClassName, subtitle, additionalYears = null,
  options = {}, printOptions = null, locale = navigator.language, monthFormat = true, legendLabels=null, showTitle = true,
  showSubtitle=true, disableRls=false, setLowAttribute, printWidget = false, passedItems = null
}) => {
  
  const [data, setData] = useState(defaultSeriesValueWidgetData);
  //const [total, setTotal] = useState(null);
  const [error, setError] = useState("");

  const setupData = ({ labels, series, total}) => {
    options.low = setLowAttribute? setLowAttribute(series) : 0;
    setData(
      { 
        "labels": monthFormat ? labels.map(l => monthMapping[l.substring(l.length-2, l.length)]) : labels,
        "series": series
      }
    );
  };

  useEffect(() => {
    if(!passedItems){
      let finalUrl = endpoint;
      if (additionalYears){
        finalUrl += `?additionalYears=${additionalYears.join(",")}`
      }
      requestHandler(finalUrl, datasource, filter, profileId, solutionId, setupData, setError, disableRls);
    } else if( data !== passedItems){
      setData(passedItems);
    }
  }, [endpoint, datasource, filter, profileId, solutionId, additionalYears, disableRls, passedItems]);

  let newWidgetClassName="shadow-sm h-100 " + widgetClassName

  return (
    <>
      { printWidget &&
      <Card border="light" className={`${newWidgetClassName} widget-hidden`}>
        <SeriesWidget 
          title={title}
          startYear={startYear}
          chartClassName={chartClassName}
          subtitle={subtitle}
          additionalYears={additionalYears}
          options={printOptions ? printOptions : options}
          locale={locale}
          legendLabels={legendLabels}
          showTitle={showTitle}
          showSubtitle={showSubtitle}
          data={data}
          error={error}
        />
      </Card>
      }
      <Card border="light" className={`${newWidgetClassName} widget-on`}>
        <SeriesWidget 
          title={title}
          startYear={startYear}
          chartClassName={chartClassName}
          subtitle={subtitle}
          additionalYears={additionalYears}
          options={options}
          locale={locale}
          legendLabels={legendLabels}
          showTitle={showTitle}
          showSubtitle={showSubtitle}
          data={data}
          error={error}
        />
      </Card>
    </>
  )
};


export default SeriesValueWidget;